module.exports = __webpack_public_path__ + "static/media/15.0d92b5c0.png";